export const priorityLevel = {
  criticalInfo: 0,
  systemLevelAnnouncement: 1,
  teachingBubble: 2,
  survey: 3,
  mobilePrompt: 3,
  SMCLandingPageDialog: 3,
  previewBar: 4,
  default: 5,
};

export const keyVault = {
  survey: 'survey',
  criticalInfo: 'critical-info',
  systemLevelAnnouncement: 'system-level-announcement',
  teachingBubble: 'teaching-bubble',
  importRecommendation: 'import-recommendation',
  conversionCoupon: 'conversion-coupon',
  lightBox: 'light-box',
  mobilePrompt: 'mobile-prompt',
  SMCLandingPageDialog: 'SMC-landing-page-dialog',
  helpPopup: 'help-popup',
  apexHelpContent: 'apex-help-content',
  floatingBanner: 'floating-banner',
  hoveringPopup: 'hovering-popup',
  clickingPopup: 'clicking-popup',
  previewBar: 'preview-bar',
};
